import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import './addLotForProductWarningModal.css';
import addLotForProductModal from '../../../src/assets/images/addLotForProductModal.png'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import React, { useState } from 'react';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiPaper-root': {
    borderRadius: theme.spacing(2), // To adjust the modal borderRadius
  },
}));

const AddLotForProductWarningModal = ({ isOpen, onClose, message }) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    onClose(false);
  };

  return (
    <React.Fragment >
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Add lot for product warning modal
      </Button> */}
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
        PaperProps={{
          style: {
            maxWidth: '370px', // Adjust the maxWidth as needed
            width: '100%',
            maxHeight: '360px'
          },
        }}
        maxHeight="300" // Adjust the maxHeight as needed

      >
        <DialogTitle sx={{ m: 0, p: "0px 0px" }} id="customized-dialog-title">
          {/* Modal title */}
          <div className='addLotForProductWarningModalImagediv'>
            <img
              className='addLotForProductWarningImage'
              src={addLotForProductModal}
            />
            <h4
              className='addLotForProductWarningModal'
            > {message} </h4>
          </div>
          <div>
            <Button className='okButton' onClick={handleClose}>
              OK
            </Button>
          </div>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            backgroundColor: "white",
            height: "7%",
            width: "6%",
          }}
        >
          <CloseIcon />
        </IconButton>
      </BootstrapDialog>
    </React.Fragment>
  );
}

export default AddLotForProductWarningModal;
